import axios from 'axios'

const loginUser = (values) =>
  axios.post(
    new URL('/admin/authenticate', import.meta.env.VITE_APP_API_BASE_URL),
    values
  )

export default loginUser
